// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.show-post-poll__answer{
    width: auto;
    border: 1px solid var(--new-line-color);
    margin: var(--space-half) var(--space);
    padding: var(--space-half);
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
}

.show-post-poll__answer.baloa-names{
    color: var(--primary-very-dark-color);
}

.show-post-poll__answer_answered{
    width: auto;
    /* border: 1px solid var(--new-line-color); */
    margin: var(--space-half) var(--space);
    /* padding: var(--space-half); */
    /* border-radius: 8px; */
    display: flex;
    justify-content: space-between;

}
.show-post-poll__answer_answered.baloa-names{
    color: var(--primary-very-dark-color);
}
progress {
	display:inline-block;
	width: 100%;
	height: 40px;
	padding: 0;
	margin:0;
	background:none;
	border: 0;
	border-radius: 8px;
	text-align: end;
	position:relative;
/* 	font-family: Arial, Helvetica, sans-serif;
	font-size: 0.8em; */
}
progress::-webkit-progress-bar {
	height: 40px;
	width: 100%;
	margin:0 auto;
	background-color: var(--white-color);    
	border-radius: 8px;
    border: 1px solid var(--new-line-color);
	/* box-shadow:0px 0px 6px #777 inset;*/
}
progress::-webkit-progress-value {
	display:inline-block;
	float: left;
	height:40px;
	margin:0px -10px 0 0;
	background: var(--new-green-color);   
    opacity: 20%;
	border-radius: 8px;
	/* box-shadow:0px 0px 6px #777 inset; */
}
progress:after {
	margin:-30px 0 0 -7px;
	padding:0;
	display:inline-block;
	float: right;
	content: attr(value) '%';
    padding-right: 16px;
}
 
.show-post-poll__counter{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-regular);
    font-size: 13px;
    line-height: 15px;
    display: flex;
    align-items: center;
    letter-spacing: 0.004em;
    color: var(--basic-gray-color);

    padding-left: var(--space);
    padding-bottom: var(--space);
}

.show-post-poll__answer_answered__caption{
    position: absolute;
    padding-top: 10px;
    padding-left: 16px;
    display: flex;
    align-items: center;
}
.show-post-poll__answer_answered-icon{
    margin-left: 10px;
}
.show-post-poll__answer_answered-icon.icon-check-single-72{
    color: var(--white-color);
    font-size: var(--space);
    font-weight: var(--font-bold);
    background: var(--new-green-color);
    border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/show-post-poll/ShowPostPollComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,uCAAuC;IACvC,sCAAsC;IACtC,0BAA0B;IAC1B,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,6CAA6C;IAC7C,sCAAsC;IACtC,gCAAgC;IAChC,wBAAwB;IACxB,aAAa;IACb,8BAA8B;;AAElC;AACA;IACI,qCAAqC;AACzC;AACA;CACC,oBAAoB;CACpB,WAAW;CACX,YAAY;CACZ,UAAU;CACV,QAAQ;CACR,eAAe;CACf,SAAS;CACT,kBAAkB;CAClB,eAAe;CACf,iBAAiB;AAClB;oBACoB;AACpB;AACA;CACC,YAAY;CACZ,WAAW;CACX,aAAa;CACb,oCAAoC;CACpC,kBAAkB;IACf,uCAAuC;CAC1C,sCAAsC;AACvC;AACA;CACC,oBAAoB;CACpB,WAAW;CACX,WAAW;CACX,oBAAoB;CACpB,kCAAkC;IAC/B,YAAY;CACf,kBAAkB;CAClB,uCAAuC;AACxC;AACA;CACC,qBAAqB;CACrB,SAAS;CACT,oBAAoB;CACpB,YAAY;CACZ,wBAAwB;IACrB,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;;IAE9B,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,6BAA6B;IAC7B,kCAAkC;IAClC,kBAAkB;AACtB","sourcesContent":[".show-post-poll__answer{\n    width: auto;\n    border: 1px solid var(--new-line-color);\n    margin: var(--space-half) var(--space);\n    padding: var(--space-half);\n    border-radius: 8px;\n    display: flex;\n    justify-content: space-between;\n    cursor: pointer;\n}\n\n.show-post-poll__answer.baloa-names{\n    color: var(--primary-very-dark-color);\n}\n\n.show-post-poll__answer_answered{\n    width: auto;\n    /* border: 1px solid var(--new-line-color); */\n    margin: var(--space-half) var(--space);\n    /* padding: var(--space-half); */\n    /* border-radius: 8px; */\n    display: flex;\n    justify-content: space-between;\n\n}\n.show-post-poll__answer_answered.baloa-names{\n    color: var(--primary-very-dark-color);\n}\nprogress {\n\tdisplay:inline-block;\n\twidth: 100%;\n\theight: 40px;\n\tpadding: 0;\n\tmargin:0;\n\tbackground:none;\n\tborder: 0;\n\tborder-radius: 8px;\n\ttext-align: end;\n\tposition:relative;\n/* \tfont-family: Arial, Helvetica, sans-serif;\n\tfont-size: 0.8em; */\n}\nprogress::-webkit-progress-bar {\n\theight: 40px;\n\twidth: 100%;\n\tmargin:0 auto;\n\tbackground-color: var(--white-color);    \n\tborder-radius: 8px;\n    border: 1px solid var(--new-line-color);\n\t/* box-shadow:0px 0px 6px #777 inset;*/\n}\nprogress::-webkit-progress-value {\n\tdisplay:inline-block;\n\tfloat: left;\n\theight:40px;\n\tmargin:0px -10px 0 0;\n\tbackground: var(--new-green-color);   \n    opacity: 20%;\n\tborder-radius: 8px;\n\t/* box-shadow:0px 0px 6px #777 inset; */\n}\nprogress:after {\n\tmargin:-30px 0 0 -7px;\n\tpadding:0;\n\tdisplay:inline-block;\n\tfloat: right;\n\tcontent: attr(value) '%';\n    padding-right: 16px;\n}\n \n.show-post-poll__counter{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-regular);\n    font-size: 13px;\n    line-height: 15px;\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.004em;\n    color: var(--basic-gray-color);\n\n    padding-left: var(--space);\n    padding-bottom: var(--space);\n}\n\n.show-post-poll__answer_answered__caption{\n    position: absolute;\n    padding-top: 10px;\n    padding-left: 16px;\n    display: flex;\n    align-items: center;\n}\n.show-post-poll__answer_answered-icon{\n    margin-left: 10px;\n}\n.show-post-poll__answer_answered-icon.icon-check-single-72{\n    color: var(--white-color);\n    font-size: var(--space);\n    font-weight: var(--font-bold);\n    background: var(--new-green-color);\n    border-radius: 50%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
